<template>
  <div class="gkui-form">
    <slot />
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  name: 'gkui-form',
  components: {
  },
  props: {
    name: VueTypes.string.isRequired,
    value: VueTypes.object.def({}).isRequired
  },
  data () {
    return {
      form: {},
      group: {},
      validitys: {},
      formData: {}
    }
  },
  provide () {
    return {
      _gkuiFormRegister: this.register,
      _gkuiFormUnregister: this.unregister,
      _gkuiFormAcceptModel: this.acceptModel
    }
  },
  computed: {
  },
  created () {
    this.$on(`form-${this.name}`, this.acceptModel)
  },
  watch: {
  },
  methods: {
    /**
     * 接收验证项的值
     * @param {Object}  model          验证项数据
     * @param {String}  model.group    验证项的分组名称
     * @param {String}  model.field    验证项的标识
     * @param {String}  model.value    验证项的值
     * @param {Boolean} model.touched  是否已验证
     * @param {Boolean} model.process  是否正在验证中
     * @param {Boolean} model.valid    验证是否已通过
     * @param {Boolean} model.invalid  验证是否失败
     * @param {Boolean} model.message  验证失败时的消息
     */
    acceptModel (model) {
      const {group, field, value = '', valid = true, touched = false, process = false, message = ''} = model
      const formData = {
        value,
        touched,
        process,
        valid,
        invalid: !valid,
        message
      }

      if (group) {
        if (!this.group[group]) {
          this.group[group] = {}
        }

        this.group[group][field] = formData
      } else {
        this.form[field] = formData
      }

      this.pushFormData()
    },
    register (validity) {
      this.validitys[`${validity.field}-${validity.group}`] = validity
      this.acceptModel({
        group: validity.group,
        field: validity.field,
        value: validity.value || ''
      })
    },
    unregister (validity) {
      delete this.validitys[`${validity.field}-${validity.group}`]

      if (validity.group) {
        delete this.group[validity.group][validity.field]
        !Object.keys(this.group[validity.group]).length && delete this.group[validity.group]
      } else {
        delete this.form[validity.field]
      }

      this.pushFormData()
    },
    validate () {
      const defer = []

      Object.keys(this.validitys).forEach(key => {
        this.validitys[key].validate && defer.push(this.validitys[key].validate())
      })

      return Promise.all(defer).then(res => {
        let valid = true
        let message = ''
        let field = ''
        let $el = ''

        for (let i = 0; i < res.length; i++) {
          const result = res[i]

          if (!result.valid) {
            valid = false
            $el = result.$el
            field = result.field
            message = result.message
            break
          }
        }

        return new Promise((resolve, reject) => {
          this.$nextTick(() => {
            valid ? resolve({
              valid,
              message,
              formData: this.formData._value
            }) : reject({
              $el,
              field,
              valid,
              message
            })
          })
        })
      })
    },
    /**
     * 自定义验证项错误
     */
    invalid (field, message, group = '') {
      const ctrl = this.validitys[`${field}-${group}`]

      if (ctrl) {
        ctrl.invalid && ctrl.invalid(message)
      } else {
        console.warn(`${field}-${group} 不存在`)
      }
    },
    /**
     * 整理成标准的验证结果
     */
    parseValidityData (form) {
      const formData = {
        valid: true,
        touched: true,
        process: true,
        _value: {}
      }

      Object.keys(form).forEach(key => {
        const field = form[key]

        formData[key] = Object.assign({}, field)
        formData._value[key] = field.value

        if (!field.touched) {
          formData.touched = false
        }

        if (field.process) {
          formData.process = true
        }

        if (!field.valid) {
          formData.valid = false

          if (!formData._message) {
            formData._message = field.message
          }
        }
      })

      formData.invalid = !formData.valid

      return formData
    },
    /**
     * 同步验证值到调用组件
     */
    pushFormData () {
      const formData = this.parseValidityData(this.form)

      if (Object.keys(this.group).length) {
        Object.keys(this.group).forEach(key => {
          if (formData[key]) {
            console.warn(`分组 "${key}" 与单项验证 "${key}" 重名`)
          }

          const group = this.parseValidityData(this.group[key])

          formData[key] = Object.assign({}, group)
          formData._value[key] = group._value

          if (!group.touched) {
            formData.touched = false
          }

          if (group.process) {
            formData.process = true
          }

          if (!group.valid) {
            formData.valid = false

            if (!formData._message) {
              formData._message = group.message
            }
          }
        })

        formData.invalid = !formData.valid
      }

      this.formData = formData

      this.$emit('input', formData)
    }
  }
}
</script>
